import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { reload, loadPage, reset } from "./usersSlice";
import AddUserForm from "../registration/components/AddUserForm";
import ActionsTable from "../../components/templates/ActionsTable";
import moment from "moment";
import "moment/locale/he";
import Active from "../../components/tables/Active";
import UserRoles from "../../components/tables/UserRoles";
import UserBranches from "../../components/tables/UserBranches";
import LinkComponent from "../../components/tables/Link";
import Phone from "../../components/tables/Phone";
import { ReactComponent as UsersImg } from "../../assets/no-users.svg";
import { useUserBranches } from "../../hooks/accessControl";
import { useRoles } from "../../hooks";

const UsersList = () => {
  const dispatch = useDispatch();
  const userBranches = useUserBranches();
  const userRoles = useRoles();
  const { page: usersPage } = useSelector((state) => state.users);
  const { current, pageSize, total, order, items, filter } = usersPage;
  const loading = useSelector(
    (state) => state.pendingActions["users/loadPage"]
  );
  const [visible, setVisible] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    moment.locale("he");
  }, [dispatch]);

  const onTextChange = (e) => {
    dispatch(
      loadPage({ current: 1, filter: { ...filter, freeText: e.target.value } })
    );
  };

  const onAddClick = () => {
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };
  return (
    <div>
      <ActionsTable
        borderless={true}
        tableItems={[
          {
            title: "name",
            responsive: ["xl"],
            sortIndex: "name",
            sorter: true,
            render: LinkComponent,
            columnProps: {
              pathTarget: "user",
            },
          },
          {
            title: "active",
            responsive: ["lg"],
            width: 120,
            render: Active,
            sorter: true,
            filters: [
              { text: <FormattedMessage id="app.forms.active" />, value: true },
              {
                text: <FormattedMessage id="app.forms.not_active" />,
                value: false,
              },
            ],
          },
          { title: "user_name", responsive: ["xxl"] },
          {
            title: "roles",
            responsive: ["lg"],
            width: 140,
            render: UserRoles,
            filters: userRoles.map((i) => ({ text: i.name, value: i.id })),
          },
          {
            title: "branches",
            responsive: ["xl"],
            ellipsis: true,
            render: UserBranches,
            filters: userBranches.map((i) => ({ text: i.name, value: i.id })),
          },
          {
            title: "phone_number",
            responsive: ["md"],
            width: 150,
            render: Phone,
          },
        ]}
        category={"users"}
        resource="users"
        paramsFilters={["branches", "roles"]}
        current={current}
        pageSize={pageSize}
        total={total}
        loading={loading}
        textFilter={filter.freeText}
        reload={reload}
        loadPage={loadPage}
        resetPage={reset}
        items={items}
        onTextChange={onTextChange}
        onAddClick={onAddClick}
        addbuttonText={<FormattedMessage id="app.users.addNewUser" />}
        headerInputPlaceholder={intl.formatMessage({
          id: "app.users.typeUserName",
        })}
        filtersType={{
          status: "boolean",
        }}
        showheader={true}
        inputStyle={300}
        emptyImage={<UsersImg />}
        emptytext={<FormattedMessage id="app.tables.noPatients" />}
      />
      <Modal
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        onCancel={hide}
        title={null}
        width={"fit-content"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        destroyOnClose={true}
      >
        <AddUserForm
          hide={hide}
          visible={visible}
          addText={<FormattedMessage id="app.users.addNewUser" />}
        />
      </Modal>
    </div>
  );
};

export default UsersList;
